import {PermissionId} from "@app/layout/admin/services/api/permission-interfaces";
import {AllowedAction} from "@app/layout/admin/services/api/util-interfaces";
import {CustomizationProperty} from "@shared/services/api/customization-property";

export enum UserEntityType {
  CUSTOMER = 'customer',
  CLIENT = 'client',
  CONTRACTOR = 'contractor'
}

export type UserEntityId = number;
export type CustomerId = UserEntityId;
export type ClientId = UserEntityId;
export type ContractorId = UserEntityId;


interface BaseAPIUserEntity {
  customer_id: CustomerId;
  is_active: boolean;
  logo_url?: string;
  permissions?: PermissionId[];
  allowed_actions?: AllowedAction[];
  customer_customization_properties?: CustomizationProperty[];
}


export interface CustomerCreateBody {
  customer_name: string;
}


export interface APICustomerEntity extends BaseAPIUserEntity, CustomerCreateBody {
}

export interface APIClientEntity extends BaseAPIUserEntity {
  client_id: ClientId;
  client_name: string;
  customer_logo_url: string;
}


export interface APIContractorEntity extends BaseAPIUserEntity {
  contractor_id: ContractorId;
  contractor_name: string;
  customer_logo_url: string;
}


export interface BaseUserEntity {
  id: UserEntityId;
  name: string;
  type: UserEntityType;
  customer_id?: CustomerId;
  customer_name?: string;
}

export interface UserEntity extends BaseUserEntity {
  logoUrl?: URL;
  customerLogoUrl?: URL;
  customerCustomizationProperties?: Map<string, any>;
  getWebsiteUrl?: () => string | null;
  getHideBranding?: () => boolean;
  getHideIntegrations?: () => boolean;
}
